import React from "react";
import styled from "styled-components/macro";

const StyledSvg = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
  cursor: pointer;
`;

interface Props {
  className?: string;
  onClick?: () => void;
  fill?: string;
}

export const InfoIcon: React.FC<Props> = ({ onClick, className, fill }) => (
  <StyledSvg
    onClick={onClick}
    className={className}
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill={fill ? fill : "var(--blue)"}
  >
    <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
  </StyledSvg>
);
